$ = require 'jquery'

# prevent user from zooming page in Chrome

((handler) -> document.addEventListener 'wheel', handler, {passive: false}) (evt) ->
    if evt.ctrlKey == true
        # it's a pinch-zoom event; Chrome does pinch-zoom as scroll with ctrl key held
        evt.preventDefault()



// WEBPACK FOOTER //
// ./src/frontend/disable-zooming-page.coffee